/**
 * Every string the back office writes itself, in Slovak.
 *
 * This object is the source of truth: its keys are the type every other language and every `t()` call is
 * checked against. A string added to a component instead of here is a defect (Conventions/06 §3).
 */
export const SK = {
  'app.name': 'Správa skladu',
  'app.title': 'Správa skladu — back office',
  'app.badge': 'back office',
  'common.retry': 'Skúsiť znova',
  'common.cancel': 'Zrušiť',
  'common.save': 'Uložiť',
  'common.create': 'Vytvoriť',
  'common.close': 'Zavrieť',
  'common.edit': 'Upraviť',
  'common.archive': 'Archivovať',
  'common.restore': 'Obnoviť',
  'common.actions': 'Akcie',
  'common.search': 'Hľadať',
  'common.all': 'Všetky',
  'common.none': '—',
  'common.unlimited': 'bez limitu',
  'layout.openMenu': 'Otvoriť menu',
  'layout.signOut': 'Odhlásiť sa',
  'theme.toLight': 'Prepnúť na svetlý režim',
  'theme.toDark': 'Prepnúť na tmavý režim',
  'theme.toggle': 'Prepnúť farebný režim',
  'language.toggle': 'Jazyk',
  'error.network.title': 'Server neodpovedá',
  'error.network.detail':
    'Back office je nastavený na {url}. Skontrolujte, či tam API beží, a skúste to znova.',
  'error.request.title': 'Chyba {status}',
  'error.unexpected.title': 'Neočakávaná chyba',
  'error.unexpected.detail':
    'Niečo sa pokazilo na strane back officeu. Podrobnosti sú v konzole prehliadača.',
  'error.requestFailed': 'Požiadavka zlyhala.',
  'pagination.range': '{from}–{to} z {count}',
  'pagination.next': 'Ďalšia strana',
  'pagination.previous': 'Predchádzajúca strana',
  'pagination.first': 'Prvá strana',
  'pagination.last': 'Posledná strana',
  'pagination.rowsPerPage': 'Riadkov na stranu',
  'nav.overview': 'Prehľad',
  'nav.stock': 'Sklad',
  'nav.products': 'Produkty',
  'nav.movements': 'Pohyby',
  'nav.administration': 'Správa',
  'nav.companies': 'Firmy',
  'nav.users': 'Používatelia',
  'nav.platform': 'Platforma',
  'nav.tenants': 'Podniky',
  'nav.audit': 'Audit',
  'role.superAdmin': 'Správca platformy',
  'role.owner': 'Vlastník',
  'role.subUser': 'Používateľ',
  'status.ACTIVE': 'Aktívny',
  'status.ARCHIVED': 'Archivovaný',
  'status.DISABLED': 'Deaktivovaný',
  'licenceState.ACTIVE': 'Platná',
  'licenceState.SUSPENDED': 'Pozastavená',
  'licenceState.EXPIRED': 'Vypršala',
  'licenceState.NOT_YET_VALID': 'Ešte neplatí',
  'actorKind.PLATFORM': 'platforma',
  'actorKind.TENANT': 'podnik',
  'actorKind.SYSTEM': 'systém',
  'movementType.RECEIPT': 'Príjem',
  'movementType.ISSUE': 'Výdaj',
  'movementType.ADJUSTMENT': 'Inventúrna úprava',
  'movementType.WRITE_OFF': 'Odpis',
  'movementReason.OPENING_FROM_SHOP': 'Počiatočný stav z e-shopu',
  'movementSource.BACK_OFFICE': 'back office',
  'movementSource.INTEGRATION': 'integrácia',
  'movementSource.SYSTEM': 'systém',
  'field.email': 'E-mail',
  'field.password': 'Heslo',
  'field.displayName': 'Meno',
  'field.tenantName': 'Názov podniku',
  'field.contactEmail': 'Kontaktný e-mail',
  'field.licenceState': 'Stav licencie',
  'field.createdAt': 'Vytvorené',
  'field.lastLoginAt': 'Naposledy prihlásený',
  'field.status': 'Stav',
  'field.company': 'Firma',
  'field.companyName': 'Názov firmy',
  'field.registrationNumber': 'IČO',
  'field.vatNumber': 'IČ DPH',
  'field.currency': 'Mena',
  'field.productName': 'Produkt',
  'field.ean': 'EAN',
  'field.sku': 'SKU',
  'field.defaultPrice': 'Predvolená cena ({currency})',
  'field.price': 'Cena šarže ({currency})',
  'field.purchasePrice': 'Nákupná cena ({currency})',
  'field.expiryDate': 'Dátum spotreby',
  'field.lotNumber': 'Číslo šarže',
  'field.batch': 'Šarža',
  'field.quantity': 'Množstvo (ks)',
  'field.reference': 'Doklad',
  'field.note': 'Poznámka',
  'field.movementType': 'Typ pohybu',
  'password.generate': 'Vygenerovať',
  'password.hint':
    'Zobrazuje sa iba teraz — odovzdajte ho skôr, než dialóg zavriete. Uložené je len ako hash.',
  'password.show': 'Zobraziť heslo',
  'password.hide': 'Skryť heslo',
  'password.reset': 'Nastaviť nové heslo',
  'password.resetTitle': 'Nové heslo — {subject}',
  'password.resetDone': 'Heslo je zmenené. Ukončených relácií: {count}.',
  'login.kind.business': 'Firma',
  'login.kind.platform': 'Platforma',
  'login.hint.business': 'Prihlásenie pre vlastníkov a používateľov podniku.',
  'login.hint.platform': 'Prihlásenie pre správcov platformy. Účet podniku sa sem neprihlási.',
  'login.submit': 'Prihlásiť sa',
  'login.busy': 'Prihlasujem…',
  'login.unreachable':
    'Server neodpovedá. Skontrolujte, či API beží, a skúste to znova. Toto nie je chyba prihlasovacích údajov.',
  'login.failed': 'Prihlásenie zlyhalo. Skúste to znova.',
  'nav.invoices': 'Faktúry',
  'nav.settings': 'Nastavenia',
  'nav.billing': 'Fakturácia',
  'licenceState.AWAITING_PAYMENT': 'Čaká na úhradu',
  'field.legalName': 'Obchodné meno',
  'field.street': 'Ulica a číslo',
  'field.city': 'Mesto',
  'field.postalCode': 'PSČ',
  'field.country': 'Krajina (kód)',
  'field.taxNumber': 'DIČ',
  'field.vatPayer': 'Platiteľ DPH',
  'field.vatRate': 'Sadzba DPH (%)',
  'field.registerEntry': 'Zápis v registri',
  'field.registerEntryHint':
    'Napr. Zapísaná v OR Mestského súdu Bratislava III, oddiel Sro, vložka č. 12345/B',
  'field.billingEmail': 'Fakturačný e-mail',
  'field.phone': 'Telefón',
  'field.web': 'Web',
  'field.bankName': 'Banka',
  'field.iban': 'IBAN',
  'field.swift': 'SWIFT',
  'field.proformaPrefix': 'Predpona zálohových faktúr',
  'field.invoicePrefix': 'Predpona faktúr',
  'field.dueDays': 'Splatnosť (dni)',
  'field.issuedBy': 'Vystavil',
  'field.months': 'Počet mesiacov',
  'field.documentType': 'Doklad',
  'field.number': 'Číslo',
  'field.buyer': 'Odberateľ',
  'field.issuedOn': 'Vystavená',
  'field.dueOn': 'Splatnosť',
  'field.total': 'Suma',
  'field.paid': 'Uhradené',
  'field.amount': 'Suma (€)',
  'field.receivedOn': 'Prijaté dňa',
  'field.paymentReference': 'Referencia platby',
  'field.variableSymbol': 'Variabilný symbol',
  'documentType.PROFORMA': 'Zálohová faktúra',
  'documentType.INVOICE': 'Faktúra',
  'invoiceStatus.ISSUED': 'Neuhradená',
  'invoiceStatus.PARTIALLY_PAID': 'Čiastočne uhradená',
  'invoiceStatus.PAID': 'Uhradená',
  'invoiceStatus.CANCELLED': 'Stornovaná',
  'invoice.overdue': 'Po splatnosti',
  'settings.title': 'Fakturačné nastavenia',
  'settings.subtitle': 'Údaje dodávateľa na každom doklade a cenník licencií.',
  'settings.missing':
    'Kým nevyplníte dodávateľa aj cenník, nedá sa vytvoriť nový podnik ani objednať licencia.',
  'settings.supplier': 'Dodávateľ',
  'settings.supplierHint': 'Tieto údaje sa vytlačia na každý nový doklad. Už vystavené doklady sa nemenia.',
  'settings.numbering': 'Číslovanie a splatnosť',
  'settings.bank': 'Bankové spojenie',
  'settings.saved': 'Uložené.',
  'settings.invalid':
    'Skontrolujte číselné polia — musia to byť celé nezáporné čísla, sadzba DPH najviac s dvoma desatinami.',
  'settings.priceList': 'Cenník',
  'settings.priceListHint':
    'Mesačné ceny bez DPH. Licencia sa vyfakturuje ako základ plus každý limit, za každý mesiac. Neobmedzený limit má vlastnú cenu.',
  'price.base': 'Základ licencie / mesiac (€)',
  'price.unit': 'Cena za blok / mesiac (€)',
  'price.unitSize': 'Veľkosť bloku',
  'price.unlimited': 'Bez limitu / mesiac (€)',
  'invoices.title': 'Faktúry',
  'invoices.subtitle': 'Zálohové faktúry a faktúry za licencie, všetkých podnikov.',
  'invoices.searchHint': 'Číslo, odberateľ alebo VS',
  'invoices.overdueOnly': 'Len po splatnosti',
  'invoices.tenantFilter': 'Podnik: {name}',
  'invoices.clearTenant': 'Všetky podniky',
  'invoices.empty': 'Žiadne doklady',
  'invoices.emptyDetail': 'Doklady vznikajú pri vytvorení podniku a pri objednávke licencie.',
  'invoice.back': 'Späť na faktúry',
  'invoice.download': 'Stiahnuť PDF',
  'invoice.recordPayment': 'Zaevidovať platbu',
  'invoice.cancel': 'Stornovať',
  'invoice.cancelConfirm':
    'Stornovať zálohovú faktúru {number}? Objednávka licencie sa zruší a odberateľovi príde správa, aby ju neuhrádzal.',
  'invoice.supplier': 'Dodávateľ',
  'invoice.buyer': 'Odberateľ',
  'invoice.lines': 'Položky',
  'invoice.line': 'Popis',
  'invoice.quantity': 'Množstvo',
  'invoice.unitPrice': 'Jedn. cena',
  'invoice.lineTotal': 'Spolu',
  'invoice.net': 'Základ',
  'invoice.vat': 'DPH {rate} %',
  'invoice.noVat': 'Dodávateľ nie je platiteľom DPH.',
  'invoice.total': 'Celkom',
  'invoice.remaining': 'Zostáva uhradiť',
  'invoice.overpaid': 'Preplatok',
  'invoice.payments': 'Platby',
  'invoice.noPayments': 'Zatiaľ žiadna platba.',
  'invoice.deletePayment': 'Odstrániť',
  'invoice.settles': 'Uhrádza zálohovú faktúru {number}',
  'invoice.openSettled': 'Otvoriť vyúčtovaciu faktúru',
  'invoice.openProforma': 'Otvoriť zálohovú faktúru',
  'invoice.order': 'Objednávka licencie',
  'invoice.orderKind.NEW': 'Nová licencia',
  'invoice.orderKind.RENEWAL': 'Predĺženie',
  'invoice.orderSummary': '{kind}, {months} mes.',
  'invoice.tenant': 'Podnik',
  'payment.title': 'Platba k {number}',
  'payment.hint':
    'Keď platby dosiahnu sumu dokladu, licencia sa aktivuje, vystaví sa faktúra a odberateľovi príde e-mailom.',
  'payment.invalidAmount': 'Zadajte sumu väčšiu ako nula, najviac s dvoma desatinami.',
  'tenants.billingCompany': 'Fakturačná firma',
  'tenants.billingCompanyHint':
    'Firma, na ktorú sa vystaví zálohová faktúra. Vytvorí sa ako prvá firma podniku; vlastník ju neskôr môže zmeniť.',
  'tenants.noBillingCompany': 'Nie je určená',
  'tenants.notBillable': 'chýba adresa alebo IČO',
  'tenants.invoices': 'Faktúry podniku',
  'tenants.firstOrder': 'Prvá licencia',
  'licence.order': 'Objednať licenciu',
  'licence.orderTitle': 'Objednávka licencie — {tenant}',
  'licence.orderHint':
    'Vystaví sa zálohová faktúra. Nové obdobie a limity začnú platiť jej úhradou; dovtedy platí súčasná licencia.',
  'licence.awaitingHint': 'Licencia čaká na úhradu zálohovej faktúry. Aktivuje sa zaevidovaním platby.',
  'licence.orderInvalid': 'Zadajte 1 až 60 mesiacov a limity ako celé čísla.',
  'quote.title': 'Cena podľa cenníka',
  'quote.unavailable': 'Cenu nemožno spočítať — vyplňte dodávateľa a cenník v nastaveniach.',
  'billing.title': 'Fakturácia',
  'billing.subtitle': 'Doklady za licenciu a firma, na ktorú sa vystavujú.',
  'billing.company': 'Fakturovať na firmu',
  'billing.companyHint':
    'Ďalšie doklady sa vystavia na zvolenú firmu. Firma musí byť aktívna a mať vyplnenú adresu a IČO — doplníte ich v Firmách.',
  'billing.saved': 'Fakturačná firma je zmenená.',
  'billing.invoices': 'Doklady',
  'billing.empty': 'Zatiaľ žiadne doklady',
  'billing.emptyDetail': 'Doklady za licenciu sa tu objavia hneď po vystavení.',
  'billing.awaiting':
    'Licencia čaká na úhradu zálohovej faktúry {number} na sumu {total}, splatnej {due}. Aktivuje sa hneď po pripísaní platby.',
  'overview.awaitingPayment':
    'Licencia čaká na úhradu zálohovej faktúry. Údaje si môžete prezerať, zmeny budú možné po úhrade.',
  'overview.toBilling': 'Zobraziť doklady',
  'companies.billingSection': 'Fakturačné údaje',
  'companies.billingHint': 'Adresa a IČO sú potrebné, aby sa na firmu dali vystaviť faktúry.',
  'login.forgot': 'Zabudli ste heslo?',
  'forgot.title': 'Obnovenie hesla',
  'forgot.hint': 'Zadajte e-mail, ktorým sa prihlasujete. Pošleme vám odkaz na nastavenie nového hesla.',
  'forgot.submit': 'Poslať odkaz',
  'forgot.busy': 'Odosielam…',
  'forgot.sent':
    'Ak k adrese {email} existuje účet, poslali sme na ňu odkaz na nastavenie nového hesla. Odkaz platí jednu hodinu.',
  'forgot.back': 'Späť na prihlásenie',
  'setPassword.title.reset': 'Nové heslo',
  'setPassword.title.invitation': 'Vitajte — nastavte si heslo',
  'setPassword.hint': 'Zvoľte si heslo, ktoré nepoužívate nikde inde. Odkaz sa dá použiť iba raz.',
  'setPassword.password': 'Nové heslo',
  'setPassword.confirm': 'Nové heslo znova',
  'setPassword.mismatch': 'Heslá sa nezhodujú.',
  'setPassword.submit': 'Nastaviť heslo',
  'setPassword.busy': 'Ukladám…',
  'setPassword.done':
    'Heslo je nastavené a všetky predchádzajúce prihlásenia boli ukončené. Teraz sa môžete prihlásiť.',
  'setPassword.toLogin': 'Prihlásiť sa',
  'setPassword.missingToken': 'Odkaz je neúplný. Otvorte ho priamo z e-mailu alebo požiadajte o nový.',
  'setPassword.requestNew': 'Požiadať o nový odkaz',
  'invitation.pending': 'Pozvaný',
  'invitation.resend': 'Poslať pozvánku znova',
  'invitation.sent': 'Pozvánka odoslaná',
  'invitation.hint':
    'Na e-mail príde pozvánka s odkazom, cez ktorý si používateľ sám nastaví heslo. Odkaz platí 7 dní.',
  'licence.validFrom': 'Platí od',
  'licence.validUntil': 'Platí do',
  'licence.validUntilHint': 'Prázdne = bez konca',
  'licence.noEnd': 'bez konca',
  'licence.limitHint': 'Prázdne = bez limitu',
  'licence.notes': 'Poznámka k licencii',
  'licence.metric.companies': 'Firmy',
  'licence.metric.subUsers': 'Používatelia',
  'licence.metric.products': 'Produkty',
  'licence.metric.totalStock': 'Zásoba spolu (ks)',
  'licence.invalid':
    'Skontrolujte licenciu: limity musia byť celé nezáporné čísla a koniec platnosti nesmie byť pred začiatkom.',
  'licence.save': 'Uložiť licenciu',
  'licence.saved': 'Licencia je uložená.',
  'licence.lowerHint':
    'Znížením limitu pod aktuálne využitie sa nič nezmaže — podnik len nebude môcť pridávať ďalšie.',
  'licence.suspend': 'Pozastaviť licenciu',
  'licence.suspendReason': 'Dôvod',
  'licence.suspendHint': 'Podnik bude okamžite len na čítanie. Dôvod sa zapíše do auditu.',
  'licence.reactivate': 'Obnoviť licenciu',
  'tenants.title': 'Podniky',
  'tenants.subtitle': 'Každý podnik na platforme, jeho vlastník a licencia.',
  'tenants.create': 'Nový podnik',
  'tenants.edit': 'Upraviť podnik',
  'tenants.owner': 'Vlastník',
  'tenants.licence': 'Licencia',
  'tenants.usage': 'Využitie licencie',
  'tenants.searchHint': 'názov alebo e-mail',
  'tenants.empty': 'Žiadny podnik',
  'tenants.emptyDetail': 'Vytvorte prvý podnik spolu s jeho vlastníkom a licenciou.',
  'tenants.back': 'Späť na podniky',
  'audit.title': 'Audit',
  'audit.subtitle': 'Každý zásah správcu platformy a každá zmena používateľov podniku.',
  'audit.when': 'Kedy',
  'audit.tenant': 'Podnik',
  'audit.actor': 'Kto',
  'audit.action': 'Akcia',
  'audit.target': 'Cieľ',
  'audit.note': 'Poznámka',
  'audit.empty': 'Žiadne záznamy',
  'audit.emptyDetail': 'Skúste iný filter akcie.',
  'overview.title': 'Prehľad',
  'overview.greeting': 'Prihlásený ako {name}.',
  'overview.readOnly':
    'Licencia podniku neplatí — údaje si môžete prezerať, ale nič meniť. Kontaktujte správcu platformy.',
  'overview.licence': 'Licencia',
  'overview.validity': 'Platí od {from} do {until}.',
  'overview.validityOpen': 'Platí od {from}, bez konca.',
  'overview.welcome': 'Vitajte. V ľavom menu sú obrazovky, ku ktorým máte prístup.',
  'companies.title': 'Firmy',
  'companies.subtitle': 'Právnické osoby podniku. Produkty a zásoby patria vždy jednej firme.',
  'companies.create': 'Nová firma',
  'companies.edit': 'Upraviť firmu',
  'companies.currencyHint': 'Trojpísmenový kód, napríklad EUR. Neskôr sa nemení.',
  'companies.empty': 'Žiadna firma',
  'companies.emptyManage': 'Vytvorte prvú firmu — až potom môžete zakladať produkty.',
  'companies.emptyAsk': 'K žiadnej firme nemáte prístup. Požiadajte vlastníka podniku.',
  'users.title': 'Používatelia',
  'users.subtitle': 'Kto smie čo, firmu po firme. Oprávnenia môžete udeliť iba tie, ktoré sami máte.',
  'users.create': 'Nový používateľ',
  'users.rights': 'Oprávnenia',
  'users.grantCount': '{count} oprávnení',
  'users.permissions': 'Oprávnenia',
  'users.permissionsTitle': 'Oprávnenia — {user}',
  'users.hiddenGrants':
    'Používateľ má aj {count} oprávnení v archivovaných firmách. Tu sa nezobrazujú a uložením zostanú zachované.',
  'users.deactivate': 'Deaktivovať',
  'users.reactivate': 'Aktivovať',
  'users.empty': 'Žiadny používateľ',
  'users.emptyDetail': 'Skúste iný filter.',
  'permissions.tenantWide': 'Celý podnik',
  'permissions.perCompany': 'Podľa firmy',
  'permissions.noCompanies': 'Podnik zatiaľ nemá žiadnu aktívnu firmu.',
  'products.title': 'Produkty',
  'products.subtitle': 'Katalóg vybranej firmy. Zásoba každého produktu je v šaržiach.',
  'products.create': 'Nový produkt',
  'products.edit': 'Upraviť produkt',
  'products.searchHint': 'názov, EAN alebo SKU',
  'products.defaultPrice': 'Predvolená cena',
  'products.batches': 'Šarže',
  'products.onHand': 'Na sklade',
  'products.eanHint': '8, 12, 13 alebo 14 číslic s platnou kontrolnou číslicou. Nepovinné.',
  'products.priceHint': 'Platí pre šarže bez vlastnej ceny. Prázdne = bez ceny.',
  'products.empty': 'Žiadny produkt',
  'products.emptyManage': 'Založte prvý produkt tejto firmy.',
  'products.emptyRead': 'Táto firma zatiaľ nemá produkty, alebo filter nič nenašiel.',
  'products.noCompany': 'Žiadna dostupná firma',
  'products.noCompanyDetail': 'Produkty patria firme. Nemáte prístup k produktom žiadnej firmy.',
  'products.back': 'Späť na produkty',
  'batches.title': 'Šarže',
  'batches.create': 'Nová šarža',
  'batches.edit': 'Ceny šarže',
  'batches.prices': 'Ceny',
  'batches.effectivePrice': 'Cena',
  'batches.purchasePrice': 'Nákupná cena',
  'batches.inherited': 'z produktu',
  'batches.noExpiry': 'bez dátumu',
  'batches.onlyInStock': 'Len so zásobou',
  'batches.priceHint': 'Prázdne = predvolená cena produktu.',
  'batches.empty': 'Žiadna šarža',
  'batches.emptyReceive': 'Zásoba vzniká príjmom. Príjem s novým dátumom spotreby alebo šaržou ju založí.',
  'batches.emptyRead': 'Produkt zatiaľ nemá zásobu, alebo filter nič nenašiel.',
  'batch.expires': 'spotreba {date}',
  'batch.lot': 'šarža {lot}',
  'batch.plain': 'bez šarže',
  'stock.receipt': 'Príjem',
  'stock.issue': 'Výdaj',
  'stock.adjustment': 'Inventúra',
  'stock.writeOff': 'Odpis',
  'stock.newBatch': 'Nová šarža…',
  'stock.fefo': 'Automaticky — najskôr exspirujúce',
  'stock.fefoHint':
    'Vydá sa najprv šarža s najbližším dátumom spotreby, potom ďalšie; šarže bez dátumu ako posledné. Exspirované šarže sú bežnou zásobou.',
  'stock.onHandShort': '{count} ks',
  'stock.counted': 'Napočítané množstvo (ks)',
  'stock.countedHint': 'Teraz evidované: {count} ks. Rozdiel sa zapíše ako pohyb.',
  'stock.piecesHint': 'Celé kusy.',
  'stock.referenceHint': 'Číslo dokladu, objednávky alebo dodacieho listu.',
  'stock.quantityInvalid': 'Množstvo musí byť celé kladné číslo.',
  'stock.batchRequired': 'Vyberte šaržu.',
  'stock.done': 'Zapísané pohyby: {count}.',
  'stock.replayed': 'Táto operácia už bola zapísaná — nič sa nezmenilo.',
  'money.invalid': 'Cenu zadajte ako číslo s nanajvýš dvoma desatinnými miestami, napríklad 12,50.',
  'movements.title': 'Pohyby',
  'movements.subtitle': 'Každá zmena zásoby vybranej firmy, od najnovšej.',
  'movements.when': 'Kedy',
  'movements.delta': 'Zmena',
  'movements.after': 'Stav po',
  'movements.who': 'Kto',
  'movements.oneProduct': 'Jeden produkt',
  'movements.empty': 'Žiadne pohyby',
  'movements.emptyDetail': 'Pohyby vznikajú príjmom, výdajom, inventúrou a odpisom na detaile produktu.',
  'movements.noCompanyDetail': 'Nemáte prístup k pohybom žiadnej firmy.',
  'nav.integrations': 'Prepojené e-shopy',
  'connectors.title': 'Moduly na stiahnutie',
  'connectors.subtitle':
    'Modul nainštalujte v e-shope (napríklad PrestaShop: Moduly → Nahrať modul) a vložte doň kľúč z prepojenia. Ponúkame verziu vydanú s touto aplikáciou, pre každú podporovanú radu verzií platformy.',
  'connectors.version': 'Verzia modulu',
  'connectors.download': 'Stiahnuť',
  'integrations.title': 'Prepojené e-shopy',
  'integrations.subtitle':
    'E-shopy prepojené s vybranou firmou. Sklad tu je hlavný: e-shop hlási objednávky a vratky a dostáva aktuálne stavy.',
  'integrations.create': 'Prepojiť e-shop',
  'integrations.shop': 'E-shop',
  'integrations.lastSeen': 'Naposledy ozval',
  'integrations.mapped': 'Spárované',
  'integrations.unmatched': 'Na spárovanie',
  'integrations.openConflicts': 'Konflikty',
  'integrations.pending': 'Čaká na odoslanie',
  'integrations.notConnected': 'Zatiaľ nepripojený',
  'integrations.empty': 'Žiadny prepojený e-shop',
  'integrations.emptyDetail':
    'Prepojenie vytvorí jednorazový kľúč, ktorý vložíte do konektora vo vašom e-shope (pre PrestaShop modul stocksync). Počet e-shopov každej platformy určuje licencia.',
  'integrations.noCompany': 'Žiadna firma',
  'integrations.noCompanyDetail': 'Nemáte prístup k prepojeným e-shopom žiadnej firmy.',
  'linkStatus.PENDING': 'Čaká na pripojenie',
  'linkStatus.ACTIVE': 'Pripojený',
  'linkStatus.DISABLED': 'Pozastavený',
  'linkStatus.REVOKED': 'Zrušený',
  'scope.stock.read': 'Čítať stavy skladu',
  'scope.stock.write': 'Hlásiť objednávky a vratky',
  'linkSettings.createTitle': 'Prepojiť e-shop',
  'linkSettings.editTitle': 'Nastavenie prepojenia',
  'linkSettings.create': 'Vytvoriť a zobraziť kľúč',
  'linkSettings.name': 'Názov',
  'linkSettings.nameHint': 'Pod týmto menom uvidíte e-shop v pohyboch a konfliktoch.',
  'linkSettings.scopes': 'Čo smie e-shop robiť',
  'linkSettings.allowlist': 'Povolené IP adresy',
  'linkSettings.allowlistHint':
    'Adresy servera e-shopu, oddelené čiarkou alebo novým riadkom (IPv4 aj rozsah /24). Prázdne = z akejkoľvek adresy.',
  'linkSettings.incomplete': 'Vyplňte názov a vyberte aspoň jedno oprávnenie.',
  'connectionToken.title': 'Kľúč na pripojenie: {name}',
  'connectionToken.once':
    'Kľúč sa zobrazuje iba teraz. Uložený je len jeho odtlačok — po zatvorení ho už nikto nezobrazí, dá sa iba vydať nový.',
  'connectionToken.token': 'Jednorazový kľúč',
  'connectionToken.copy': 'Kopírovať kľúč',
  'connectionToken.copied': 'Skopírované do schránky.',
  'connectionToken.validUntil': 'Platí do {when} a dá sa použiť iba raz.',
  'connectionToken.stepsTitle': 'Ako pripojiť e-shop',
  'connectionToken.step2': 'V nastaveniach konektora vložte tento kľúč a kliknite na Pripojiť.',
  'connectionToken.step3':
    'Konektor odošle katalóg na spárovanie — nič iné. Kým v detaile e-shopu nezvolíte prvú synchronizáciu, žiadne množstvo sa nemení a objednávky e-shopu len čakajú.',
  'connectionToken.done': 'Mám ho uložený',
  'detail.newToken': 'Nový kľúč',
  'detail.repair': 'Znovu spárovať',
  'detail.fullSync': 'Úplná synchronizácia',
  'detail.pause': 'Pozastaviť',
  'detail.resume': 'Obnoviť',
  'detail.revoke': 'Zrušiť prepojenie',
  'detail.revokeTitle': 'Zrušiť prepojenie {name}?',
  'detail.revokeMessage':
    'E-shop okamžite stratí prístup a jeho tajný kľúč sa zničí. Zrušené prepojenie sa nedá obnoviť — uvoľní však miesto v licencii pre nové.',
  'detail.pendingHint': 'E-shop ešte nie je pripojený. Kľúč platí do {when}.',
  'detail.tokenExpired': 'E-shop nie je pripojený a jeho kľúč už neplatí. Vydajte nový.',
  'detail.fullSyncPending':
    'Úplná synchronizácia je vyžiadaná ({when}). E-shop ju spustí pri najbližšom spojení.',
  'detail.versions': 'Verzie',
  'detail.connected': 'Pripojený',
  'detail.lastDelivered': 'Naposledy prijal stavy',
  'detail.lastFullSync': 'Posledná úplná synchronizácia',
  'detail.anyAddress': 'Akákoľvek adresa',
  'detail.tabMappings': 'Položky ({count} na spárovanie)',
  'detail.tabConflicts': 'Konflikty ({count})',
  'detail.tabLog': 'Záznam komunikácie',
  'detail.tabListings': 'Produkty v e-shope',
  'listings.notSupported':
    'Modul v e-shope neprijíma produkty z aplikácie — posiela sa mu len stav zásob. Nainštalujte jeho novšiu verziu.',
  'listings.firstSyncPending': 'Produkty sa do e-shopu posielajú po prvej synchronizácii.',
  'listings.publish': 'Publikovať produkty',
  'listings.resend': 'Odoslať všetko znova',
  'listings.importAll': 'Prevziať všetko z e-shopu',
  'listings.publishSelected': 'Publikovať vybrané',
  'listings.unpublishSelected': 'Skryť vybrané',
  'listings.importSelected': 'Prevziať vybrané z e-shopu',
  'listings.selected': 'Vybrané: {count}',
  'listings.product': 'Produkt',
  'listings.visibility': 'V e-shope',
  'listings.published': 'Publikovaný',
  'listings.hidden': 'Skrytý',
  'listings.shopId': 'ID v e-shope',
  'listings.lastSent': 'Naposledy odoslaný',
  'listings.skipped': 'E-shop vynechal: {list}',
  'listings.importPending': 'Čaká na prevzatie z e-shopu',
  'listings.imported': 'Prevzatý z e-shopu {when}',
  'listings.importError': 'Prevzatie: {error}',
  'listings.republish': 'Publikovať',
  'listings.unpublish': 'Skryť',
  'listings.take': 'Prevziať',
  'listings.empty': 'Žiadne produkty',
  'listings.emptyDetail':
    'Produkty, ktoré e-shop predáva, sa tu objavia po prvej synchronizácii alebo keď ich publikujete.',
  'listings.publishTitle': 'Publikovať produkty v e-shope {name}',
  'listings.publishHint':
    'E-shop vytvorí produkty, ktoré ešte nemá, a aktualizuje tie, ktoré má. Nikdy nič nezmaže.',
  'listings.byProducts': 'Vybrané produkty',
  'listings.byCategory': 'Kategória aj s podkategóriami',
  'listings.byAll': 'Všetky aktívne produkty',
  'listings.products': 'Produkty, ktoré e-shop ešte nepredáva',
  'listings.category': 'Kategória',
  'listings.resendTitle': 'Odoslať všetky produkty znova?',
  'listings.resendMessage':
    'Pri ďalšom doručení sa do e-shopu pošle každý publikovaný produkt aj s kategóriami, značkami a vlastnosťami — aj ten, ktorý sa nezmenil.',
  'listings.importAllTitle': 'Prevziať všetky produkty z e-shopu?',
  'listings.importAllMessage':
    'E-shop pošle svoje údaje o každom produkte, ktorý má. Aplikácia doplní len to, čo jej chýba — nič neprepíše.',
  'listings.done': 'Hotovo: {count} produktov.',
  'listingState.PENDING': 'Čaká na odoslanie',
  'listingState.SENT': 'V e-shope',
  'listingState.FAILED': 'Chyba',
  'productShops.title': 'E-shopy',
  'productShops.hint': 'V ktorých e-shopoch je produkt publikovaný a ako sa tam dostal.',
  'productShops.empty': 'Produkt nie je v žiadnom e-shope.',
  'detail.fillFromShop': 'Naplniť z e-shopu',
  'detail.fillFromShopTitle': 'Naplniť aplikáciu z e-shopu {name}?',
  'detail.fillFromShopMessage':
    'E-shop pri najbližšom behu pošle svoje produkty. Tie, ktoré aplikácia nemá, sa vytvoria aj s ich množstvom; nič, čo aplikácia má, sa neprepíše a jeho množstvo sa nezmení.',
  'detail.importPending':
    'Čaká sa na produkty z e-shopu (vyžiadané {when}). E-shop ich pošle pri najbližšom behu.',
  'integrations.awaitingChoice': 'Čaká na prvú synchronizáciu',
  'firstSync.title': 'Prvá synchronizácia',
  'firstSync.awaiting':
    'E-shop je pripojený, ale nič sa nesynchronizuje, kým nezvolíte, ktorá strana platí. Katalóg e-shopu je už spárovaný s produktmi aplikácie; objednávky z e-shopu sa zaznamenávajú a ich pohyb skladu čaká na vašu voľbu.',
  'firstSync.held': 'Zadržané objednávky a vrátenia: {count}',
  'firstSync.matched': 'Spárované položky: {mapped} · položky e-shopu bez produktu v aplikácii: {unmatched}',
  'firstSync.overwrites': 'Čo sa prepíše',
  'firstSync.creates': 'Čo sa vytvorí',
  'firstSync.heldOrders': 'Zadržané objednávky',
  'firstSync.APP_TO_SHOP': 'Aktualizovať e-shop z aplikácie',
  'firstSync.APP_TO_SHOP.overwrites':
    'Množstvá spárovaných položiek v e-shope sa prepíšu stavom skladu v aplikácii. Aplikácia zostáva bez zmeny.',
  'firstSync.APP_TO_SHOP.creates':
    'Nič. Produkty aplikácie, ktoré e-shop nemá ({count}), môžete publikovať na karte Produkty v e-shope; produkty e-shopu bez produktu v aplikácii zostanú nespárované.',
  'firstSync.APP_TO_SHOP.held':
    'Odpíšu sa zo skladu aplikácie hneď po voľbe, v poradí, v akom prišli — na stav, ktorý potom dostane e-shop.',
  'firstSync.SHOP_TO_APP': 'Naplniť aplikáciu z e-shopu',
  'firstSync.SHOP_TO_APP.overwrites':
    'Nič. Produkty, ktoré aplikácia už má, sa iba doplnia tam, kde im chýba EAN, kód alebo cena.',
  'firstSync.SHOP_TO_APP.creates':
    'Produkty e-shopu, ktoré aplikácia nemá — s názvom, kódmi, cenou s DPH, variantmi a šaržami podľa expirácie. Množstvá z e-shopu vstúpia do skladu ako príjem „Počiatočný stav z e-shopu“ všade, kde aplikácia nič nemá.',
  'firstSync.SHOP_TO_APP.held':
    'Tie spred snímky e-shopu už sú v jeho množstvách — iba sa zaznamenajú, aby sa predaj nezapočítal dvakrát. Neskoršie sa odpíšu.',
  'firstSync.unsupported':
    'Vyžaduje modul e-shopu verzie 1.2.0 alebo novšej (teraz {version}) a oprávnenie zapisovať zmeny skladu.',
  'firstSync.choose': 'Zvoliť',
  'firstSync.confirmTitle': '{direction}?',
  'firstSync.confirm.APP_TO_SHOP':
    'Množstvá spárovaných položiek v e-shope sa prepíšu stavom skladu aplikácie a {count} zadržaných zmien sa odpíše. Voľba sa nedá vrátiť.',
  'firstSync.confirm.SHOP_TO_APP':
    'E-shop pri najbližšom behu pošle všetky svoje produkty a ich množstvá. Čo aplikácia nemá, vytvorí sa; nič sa neprepíše. Voľba sa nedá vrátiť.',
  'firstSync.importing':
    'Čaká sa na produkty z e-shopu — pošle ich pri najbližšom behu (cron alebo „Synchronizovať teraz“ v module). Doteraz prijatých položiek: {items}.',
  'firstSync.done': '{direction} — zvolil {who}, {when}.',
  'firstSync.result.productsCreated': 'Vytvorené produkty',
  'firstSync.result.variantsCreated': 'Vytvorené varianty',
  'firstSync.result.batchesCreated': 'Vytvorené šarže',
  'firstSync.result.filled': 'Doplnené produkty',
  'firstSync.result.receipts': 'Počiatočné príjmy',
  'firstSync.result.receiptQuantity': 'Prijatých kusov',
  'firstSync.result.stockKept': 'Ponechaný stav aplikácie',
  'firstSync.result.skipped': 'Preskočené',
  'firstSync.result.failed': 'Odmietnuté',
  'firstSync.result.heldApplied': 'Zadržané zmeny odpísané',
  'firstSync.result.heldAbsorbed': 'Zadržané zmeny už v snímke',
  'firstSync.unlisted': 'Produkty aplikácie, ktoré e-shop nemá: {count}',
  'firstSync.unlistedHint':
    'Publikujete ich na karte Produkty v e-shope, ak modul v e-shope prijíma produkty.',
  'firstSync.unlistedMore': '… a ďalších {count}',
  'mappingStatus.MATCHED': 'Spárovaná',
  'mappingStatus.UNMATCHED': 'Nespárovaná',
  'mappingStatus.IGNORED': 'Ignorovaná',
  'matchMethod.EAN': 'podľa EAN',
  'matchMethod.REFERENCE': 'podľa kódu',
  'matchMethod.MANUAL': 'ručne',
  'matchMethod.CREATED': 'vytvorená pre šaržu',
  'matchMethod.IMPORTED': 'vytvorená z e-shopu',
  'unmatchedReason.NO_PRODUCT': 'žiadny produkt s týmto EAN ani kódom',
  'unmatchedReason.NO_BATCH': 'produkt nemá šaržu s touto expiráciou',
  'mapping.shopName': 'Položka v e-shope',
  'mapping.codes': 'EAN · kód',
  'mapping.appProduct': 'Produkt v sklade',
  'mapping.map': 'Spárovať',
  'mapping.change': 'Zmeniť',
  'mapping.unmap': 'Zrušiť párovanie',
  'mapping.ignore': 'Ignorovať',
  'mapping.empty': 'Žiadne položky',
  'mapping.emptyDetail':
    'Položky pribudnú, keď e-shop pošle svoj katalóg — pri pripojení a pri úplnej synchronizácii.',
  'mapping.title': 'Spárovať položku e-shopu',
  'mapping.shopItem': '{name} (#{id})',
  'mapping.product': 'Produkt v sklade',
  'mapping.batch': 'Šarža',
  'mapping.batchHint': 'Celý produkt: e-shop uvidí súčet šarží a objednávka sa vydá od najskoršej expirácie.',
  'mapping.batchHintExpiry': 'Variant s dátumom exspirácie je šarža produktu.',
  'mapping.wholeProduct': 'Celý produkt (výdaj od najskoršej expirácie)',
  'mapping.newBatch': 'Nová šarža s expiráciou {date}',
  'conflicts.show': 'Zobraziť',
  'conflicts.open': 'Otvorené',
  'conflicts.kind': 'Druh',
  'conflicts.order': 'Objednávka',
  'conflicts.quantity': 'Kusov',
  'conflicts.detail': 'Čo sa stalo',
  'conflicts.resolved': 'Vyriešené',
  'conflicts.resolve': 'Vyriešené',
  'conflicts.bySystem': 'automaticky',
  'conflicts.empty': 'Žiadne konflikty',
  'conflicts.emptyDetail':
    'Konflikt vznikne, keď e-shop predá viac, než je na sklade, nahlási nespárovanú položku alebo je nedostupný.',
  'conflictKind.OVERSELL': 'Predaj bez zásoby',
  'conflictKind.UNMAPPED': 'Nespárovaná položka',
  'conflictKind.REJECTED': 'Odmietnutá zmena',
  'conflictKind.UNREACHABLE': 'E-shop nedostupný',
  'log.flow': 'Smer',
  'log.IN': 'E-shop → sklad',
  'log.OUT': 'Sklad → e-shop',
  'log.operation': 'Operácia',
  'log.outcome': 'Výsledok',
  'log.items': 'Položiek',
  'log.duration': 'Trvanie',
  'log.detail': 'Podrobnosti',
  'log.empty': 'Zatiaľ žiadna komunikácia',
  'log.emptyDetail': 'Každá požiadavka v oboch smeroch sa tu zapíše — aj odmietnutá.',
  'logOutcome.OK': 'v poriadku',
  'logOutcome.PARTIAL': 'čiastočne',
  'logOutcome.REJECTED': 'odmietnuté',
  'logOutcome.ERROR': 'chyba',
  'licence.integrationHint': 'Koľko e-shopov smie byť prepojených. Prázdne = bez prepojenia.',
  'platformIntegrations.title': 'Prepojené e-shopy',
  'platformIntegrations.subtitle': 'Všetky e-shopy všetkých podnikov a ako sú na tom.',
  'platformIntegrations.tenant': 'Podnik · firma',
  'platformIntegrations.attention': 'Pozornosť',
  'platformIntegrations.needsAttention': 'Konflikty, nespárované alebo neodoslané',
  'platformIntegrations.empty': 'Žiadny prepojený e-shop',
  'platformIntegrations.emptyDetail': 'Podnik prepojí e-shop sám, ak to jeho licencia povoľuje.',
  'platform.PRESTASHOP': 'PrestaShop',
  'licence.metric.integrationLinks': 'Prepojené e-shopy {platform}',
  'price.integrationLink': 'Prepojený e-shop {platform} (€ / mesiac)',
  'price.integrationLinkHint': 'Za každý e-shop tejto platformy, ktorý licencia povoľuje.',
  'linkSettings.platform': 'Platforma e-shopu',
  'linkSettings.platformHint':
    'Prepojenie použije iba konektor tejto platformy; počíta sa do jej položky v licencii.',
  'detail.versionsValue': '{platform} {version} · konektor {connector}',
  'connectionToken.install.PRESTASHOP':
    'V administrácii PrestaShopu nainštalujte modul „Synchronizácia skladu“ (stocksync).',
  'common.delete': 'Zmazať',
  'common.moveUp': 'Posunúť vyššie',
  'common.moveDown': 'Posunúť nižšie',
  'nav.optionGroups': 'Možnosti variantov',
  'field.variant': 'Variant',
  'optionGroups.title': 'Možnosti variantov',
  'optionGroups.subtitle': 'Podľa čoho sa produkty firmy líšia vo variantoch — veľkosť, farba, balenie.',
  'optionGroups.create': 'Nová skupina',
  'optionGroups.rename': 'Premenovať skupinu',
  'optionGroups.name': 'Názov skupiny',
  'optionGroups.values': 'Hodnoty',
  'optionGroups.editValues': 'Hodnoty',
  'optionGroups.valuesTitle': 'Hodnoty skupiny {name}',
  'optionGroups.newValue': 'Nová hodnota',
  'optionGroups.addValue': 'Pridať',
  'optionGroups.renameValue': 'Premenovať hodnotu',
  'optionGroups.noValues': 'Zatiaľ bez hodnôt',
  'optionGroups.position': 'Poradie',
  'optionGroups.searchHint': 'názov skupiny alebo hodnota',
  'optionGroups.empty': 'Žiadna skupina možností',
  'optionGroups.emptyManage': 'Pridajte prvú skupinu, napríklad Veľkosť s hodnotami S, M, L.',
  'optionGroups.emptyRead': 'Firma zatiaľ nemá skupiny možností, alebo filter nič nenašiel.',
  'optionGroups.deleteTitle': 'Zmazať skupinu {name}?',
  'optionGroups.deleteMessage':
    'Skupina sa zmaže aj so všetkými hodnotami. Kým sa podľa nej líši niektorý produkt, zmazať sa nedá.',
  'products.variants': 'Varianty',
  'variants.title': 'Varianty',
  'variants.create': 'Nový variant',
  'variants.edit': 'Upraviť variant',
  'variants.enable': 'Predávať vo variantoch',
  'variants.axes': 'Možnosti produktu',
  'variants.axesTitle': 'Podľa čoho sa produkt líši',
  'variants.axesHint':
    'Vyberte skupiny možností v poradí, v akom pomenúvajú varianty. Prázdne = produkt bez variantov.',
  'variants.axesDefault': 'Hodnota „{group}“ pre existujúce varianty',
  'variants.axesDefaultHint': 'Existujúce varianty túto možnosť ešte nemajú — dostanú vybranú hodnotu.',
  'variants.axesNone': 'Firma nemá skupiny možností. Založte ich v časti Možnosti variantov.',
  'variants.manageGroups': 'Spravovať možnosti',
  'variants.values': 'Hodnoty',
  'variants.default': 'Predvolený',
  'variants.makeDefault': 'Predvolený variant (predvybraný v e-shope)',
  'variants.price': 'Cena variantu ({currency})',
  'variants.priceHint': 'S DPH. Prázdne = cena produktu.',
  'variants.inherited': 'z produktu',
  'variants.noValues': 'bez hodnôt',
  'variants.needValues': 'Produkt má možnosti, no tento variant ešte nemá hodnoty — zadajte mu ich.',
  'variants.valueRequired': 'Vyberte hodnotu pre každú možnosť produktu.',
  'variants.remove': 'Odstrániť',
  'variants.removeTitle': 'Odstrániť variant {name}?',
  'variants.removeArchive':
    'Variant má šarže, preto sa archivuje: zostane aj so zásobou, no nové šarže ani príjmy nedostane.',
  'variants.removeDelete': 'Variant nemá šarže — zmaže sa.',
  'variants.onlyActive': 'Len aktívne',
  'variants.empty': 'Žiadny variant',
  'variants.emptyDetail': 'Filter nič nenašiel.',
  'batches.allVariants': 'Všetky varianty',
  'stock.variantRequired': 'Vyberte variant.',
  'mapping.variant': 'Variant',
  'mapping.wholeVariable': 'Celý produkt (všetky varianty)',
  'mapping.variantHint':
    'Položka e-shopu je jeden variant produktu; celý produkt uvidí súčet všetkých variantov.',
  'nav.contentLanguages': 'Jazyky obsahu',
  'languages.title': 'Jazyky obsahu',
  'languages.subtitle': 'Jazyky, v ktorých podnik píše názvy produktov, skupín možností a ich hodnôt.',
  'languages.ruleDefault':
    'Prvý jazyk je predvolený: texty v ňom sú povinné a zobrazujú sa v zoznamoch a vyhľadávaní.',
  'languages.ruleSwitch':
    'Iný jazyk sa stane predvoleným presunom na prvé miesto — iba ak v ňom má text každý produkt, skupina možností aj hodnota.',
  'languages.ruleRemove':
    'Odobratý jazyk sa skryje, no jeho texty zostanú uložené a po opätovnom pridaní sa vrátia.',
  'languages.default': 'Predvolený',
  'languages.defaultTab': '{code} · predvolený',
  'languages.defaultNotRemovable':
    'Predvolený jazyk nemožno odobrať — najprv presuňte iný jazyk na prvé miesto.',
  'languages.remove': 'Odobrať jazyk',
  'languages.add': 'Pridať jazyk',
  'languages.addButton': 'Pridať',
  'languages.readOnly': 'Jazyky obsahu mení vlastník podniku alebo ten, kto má oprávnenie „Jazyky obsahu“.',
  'languages.switchWarning':
    'Predvoleným jazykom sa stane {name}. Uloženie sa podarí, len ak sú v ňom vyplnené všetky texty — inak sa dozviete, koľko ich chýba.',
  'languages.removeNotice': 'Odoberáte: {names}. Ich texty zostanú uložené a skryté.',
  'languages.saved': 'Jazyky obsahu sú uložené.',
  'languages.missing': 'Preklad chýba',
  'languages.missingIn': 'chýba: {codes}',
  'languages.translationHint': 'Nepovinné. Prázdne pole preklad zmaže.',
  'languages.defaultRequired': 'Vyplňte text v predvolenom jazyku.',
  'languages.productMissing': 'Názov produktu chýba v jazykoch: {codes}. Doplníte ho v úprave produktu.',
  'products.section.texts': 'Texty',
  'products.section.codes': 'Kódy',
  'products.section.prices': 'Ceny',
  'products.section.measures': 'Rozmery a hmotnosť',
  'products.section.display': 'Zobrazenie',
  'products.section.stock': 'Sklad',
  'field.shortDescription': 'Krátky popis',
  'field.description': 'Popis',
  'field.slug': 'Adresa (slug)',
  'products.slugHint': 'Malé písmená bez diakritiky, číslice a pomlčky. Prázdne = vytvorí sa z názvu.',
  'products.slugGenerate': 'Vytvoriť z názvu',
  'products.htmlHint':
    'HTML: p, br, strong, em, u, ul, ol, li, a, h2–h4, blockquote. Ostatné sa pri uložení odstráni.',
  'products.htmlEdit': 'Upraviť',
  'products.htmlPreview': 'Náhľad',
  'products.previewEmpty': 'Zatiaľ bez textu.',
  'field.mpn': 'MPN (kód výrobcu)',
  'field.grossPrice': 'Cena s DPH ({currency})',
  'products.grossPriceHint': 'Bežná cena. Platí pre šarže bez vlastnej ceny. Prázdne = bez ceny.',
  'products.netPrice': 'Bez DPH: {price}',
  'field.salePrice': 'Akciová cena s DPH ({currency})',
  'products.saleHint': 'Nižšia ako bežná cena. Bez dátumov platí stále.',
  'field.saleFrom': 'Akcia od',
  'field.saleTo': 'Akcia do',
  'field.costPrice': 'Nákladová cena bez DPH ({currency})',
  'products.costHint': 'Nákupná cena novej šarže, keď príjem neuvedie inú.',
  'field.weightGrams': 'Hmotnosť (g)',
  'field.widthMm': 'Šírka (mm)',
  'field.heightMm': 'Výška (mm)',
  'field.depthMm': 'Hĺbka (mm)',
  'field.visibility': 'Viditeľnosť',
  'visibility.EVERYWHERE': 'Všade',
  'visibility.CATALOGUE': 'Len v katalógu',
  'visibility.SEARCH': 'Len vo vyhľadávaní',
  'visibility.HIDDEN': 'Skrytý',
  'field.featured': 'Odporúčaný produkt',
  'products.featured': 'Odporúčaný',
  'products.featuredOnly': 'Len odporúčané',
  'field.backorders': 'Keď nie je na sklade',
  'backorders.DENY': 'Objednávku neprijať',
  'backorders.ALLOW': 'Objednávku prijať',
  'backorders.ALLOW_NOTIFY': 'Prijať a upozorniť zákazníka',
  'field.lowStockThreshold': 'Hranica nízkej zásoby (ks)',
  'field.minOrderQuantity': 'Minimálne množstvo na objednávku (ks)',
  'products.wholeNumber': 'Hmotnosť, rozmery a hranica zásoby sú celé nezáporné čísla.',
  'products.minQuantityInvalid': 'Minimálne množstvo na objednávku je celé číslo, aspoň 1.',
  'products.saleNotBelow': 'Akciová cena musí byť nižšia ako bežná cena.',
  'products.saleWindowReversed': 'Akcia nemôže skončiť skôr, ako začne.',
  'products.saleWithoutPrice': 'Obdobie akcie zadajte spolu s akciovou cenou.',
  'products.price': 'Cena s DPH',
  'products.vat': 'DPH',
  'products.onSale': 'Akcia',
  'products.priceNow': 'Cena teraz',
  'products.regularPrice': 'Bežná cena',
  'products.properties': 'Vlastnosti',
  'products.saleNone': 'Bez akcie',
  'products.saleAlways': 'platí stále',
  'products.saleEnded': 'skončila',
  'products.saleRunning': 'prebieha',
  'products.saleComing': 'pripravená',
  'products.saleWindow': '{from} – {to}',
  'products.dimensions': '{width} × {height} × {depth} mm',
  'products.noDescription': 'Bez popisu v tomto jazyku.',
  'products.hiddenHint': 'Viditeľnosť: {visibility}',
  'variants.weightHint': 'Prázdne = hmotnosť produktu.',
  'common.yes': 'áno',
  'common.no': 'nie',
  'variants.weightInvalid': 'Hmotnosť je celé nezáporné číslo.',
  'gallery.title': 'Fotky',
  'gallery.count': '{count} z {max}',
  'gallery.add': 'Pridať fotky',
  'gallery.dropHint':
    'Fotky sem môžete pretiahnuť zo súborov. Poradie zmeníte potiahnutím fotky alebo šípkami; hviezdička označí hlavnú fotku.',
  'gallery.empty': 'Produkt zatiaľ nemá fotky',
  'gallery.emptyManage':
    'Pretiahnite sem fotky alebo ich vyberte — JPEG, PNG, WebP alebo HEIC, najviac 15 MB každú.',
  'gallery.emptyRead': 'Fotky pridáva ten, kto môže upravovať produkty.',
  'gallery.tooLarge': 'Fotka je príliš veľká — najviac {max} MB.',
  'gallery.upload.waiting': 'Čaká',
  'gallery.upload.sending': 'Nahráva sa',
  'gallery.upload.done': 'Nahraná',
  'gallery.upload.refused': 'Odmietnutá',
  'gallery.clearUploads': 'Skryť zoznam nahrávania',
  'gallery.main': 'Hlavná fotka',
  'gallery.makeMain': 'Nastaviť ako hlavnú',
  'gallery.altMissing': 'Chýba popis',
  'gallery.moveEarlier': 'Posunúť dopredu',
  'gallery.moveLater': 'Posunúť dozadu',
  'gallery.edit': 'Popis a varianty',
  'gallery.editTitle': 'Fotka — popis a varianty',
  'gallery.alt': 'Popis fotky (alt)',
  'gallery.altHint': 'Krátko, čo je na fotke — pre čítačky obrazovky a vyhľadávače. Najviac 255 znakov.',
  'gallery.variants': 'Varianty na fotke',
  'gallery.variantsHint': 'Bez výberu fotka patrí produktu ako celku.',
  'gallery.removeTitle': 'Zmazať fotku?',
  'gallery.removeMessage': 'Fotka zmizne z galérie produktu. Túto akciu nemožno vrátiť.',
  'gallery.removeMainMessage':
    'Fotka zmizne z galérie produktu a hlavnou sa stane nasledujúca. Túto akciu nemožno vrátiť.',
  'gallery.view': 'Zobraziť fotku {position}',
  'gallery.preview': 'Náhľad fotky',
  'gallery.previous': 'Predchádzajúca fotka',
  'gallery.next': 'Nasledujúca fotka',
  'gallery.position': '{position} z {count}',
  'gallery.noPhoto': 'Bez fotky',
  'tenants.imageStorage': 'Fotky v úložisku: {size}',
  'nav.orders': 'Objednávky',
  'orders.title': 'Objednávky',
  'orders.subtitle': 'Objednávky prepojených e-shopov — prichádzajú iba z e-shopov, aplikácia ich nemení.',
  'orders.noCompanyDetail': 'Objednávky patria firme, ktorej e-shopy sú prepojené. Najprv vytvorte firmu.',
  'orders.shop': 'E-shop',
  'orders.reference': 'Číslo',
  'orders.placedAt': 'Vytvorená',
  'orders.customer': 'Zákazník',
  'orders.status': 'Stav',
  'orders.total': 'Spolu s DPH',
  'orders.from': 'Od',
  'orders.to': 'Do',
  'orders.search': 'Číslo, meno alebo e-mail',
  'orders.empty': 'Žiadne objednávky',
  'orders.emptyDetail':
    'Objednávky pribudnú, keď ich pošle e-shop s modulom, ktorý ich hlási (PrestaShop stocksync 1.3.0 a novší). Skúste aj zmeniť filtre.',
  'orders.past': 'z histórie',
  'orders.pastHint':
    'Staršia objednávka, ktorú e-shop poslal po prvej synchronizácii — iba sa zobrazuje, zásoby nemenila.',
  'orderStatus.NEW': 'Nová',
  'orderStatus.PAID': 'Zaplatená',
  'orderStatus.PROCESSING': 'Spracováva sa',
  'orderStatus.SHIPPED': 'Odoslaná',
  'orderStatus.DELIVERED': 'Doručená',
  'orderStatus.CANCELLED': 'Zrušená',
  'orderStatus.RETURNED': 'Vrátená',
  'orderStatus.OTHER': 'Iný stav',
  'order.title': 'Objednávka {reference}',
  'order.subtitle': '{shop} · {platform} · číslo v e-shope {id}',
  'order.oneWay':
    'Objednávky sa do aplikácie len prenášajú z e-shopu. Zmeniť objednávku treba v e-shope — sem príde jej nový stav.',
  'order.customer': 'Zákazník',
  'order.billing': 'Fakturačná adresa',
  'order.delivery': 'Doručovacia adresa',
  'order.noAddress': 'E-shop ju neposlal.',
  'order.vatId': 'IČ DPH {vatId}',
  'order.payment': 'Platba',
  'order.shipping': 'Doprava',
  'order.lines': 'Položky',
  'order.item': 'Položka',
  'order.quantity': 'Ks',
  'order.unitNet': 'Cena bez DPH',
  'order.unitGross': 'Cena s DPH',
  'order.vat': 'DPH',
  'order.lineTotal': 'Spolu s DPH',
  'order.unmatched': 'Nespárovaná s produktom',
  'order.shopIds': 'v e-shope {product}{variant}',
  'order.totals': 'Súčty',
  'order.productsTotal': 'Tovar s DPH',
  'order.shippingTotal': 'Doprava s DPH',
  'order.discountTotal': 'Zľavy s DPH',
  'order.totalNet': 'Spolu bez DPH',
  'order.totalGross': 'Spolu s DPH',
  'order.paid': 'Zaplatené',
  'order.history': 'História stavov',
  'order.stockChanges': 'Zmeny zásob z e-shopu',
  'order.stockChangesHint':
    'Zásoby menia len tieto zmeny, ktoré e-shop posiela k položkám — nie objednávka samotná.',
  'order.noStockChanges': 'E-shop k tejto objednávke zmenu zásob neposlal.',
  'changeReason.ORDER': 'Objednávka',
  'changeReason.CANCEL': 'Zrušenie',
  'changeReason.RETURN': 'Vrátenie',
  'changeOutcome.APPLIED': 'pripísané',
  'changeOutcome.PARTIAL': 'čiastočne — tovar chýbal',
  'changeOutcome.UNMAPPED': 'nespárovaná položka',
  'changeOutcome.REJECTED': 'odmietnuté',
  'changeOutcome.HELD': 'čaká na prvú synchronizáciu',
  'changeOutcome.ABSORBED': 'už v stave z e-shopu',
  'detail.tabOrders': 'Objednávky',
  'detail.ordersHistory': 'Staršie objednávky',
  'detail.ordersHistoryAwaited': 'čakajú sa z e-shopu',
  'detail.ordersHistoryDone': 'prenesené {when}',
  'products.orders': 'Objednávky z e-shopov',
  'products.ordersHint': 'Objednávky, v ktorých bol tento produkt.',
  'nav.categories': 'Kategórie',
  'nav.brands': 'Značky',
  'nav.tags': 'Štítky',
  'nav.features': 'Vlastnosti',
  'categories.title': 'Kategórie',
  'categories.subtitle': 'Strom kategórií firmy — produkt môže byť vo viacerých, jedna z nich je hlavná.',
  'categories.create': 'Nová kategória',
  'categories.createChild': 'Pridať podkategóriu',
  'categories.edit': 'Upraviť kategóriu',
  'categories.name': 'Názov',
  'categories.description': 'Popis',
  'categories.slug': 'Adresa (slug)',
  'categories.slugHint': 'Prázdna sa vytvorí z názvu.',
  'categories.parent': 'Nadradená kategória',
  'categories.top': 'Najvyššia úroveň',
  'categories.active': 'Zobrazovať v e-shopoch',
  'categories.inactive': 'skrytá',
  'categories.products': 'Produkty',
  'categories.productsHint': '{direct} priamo · {total} vrátane podkategórií',
  'categories.expandAll': 'Rozbaliť všetko',
  'categories.collapseAll': 'Zbaliť všetko',
  'categories.expand': 'Rozbaliť',
  'categories.collapse': 'Zbaliť',
  'categories.indent': 'Vnoriť pod kategóriu vyššie',
  'categories.outdent': 'Vysunúť o úroveň vyššie',
  'categories.searchHint': 'názov v ktoromkoľvek jazyku',
  'categories.empty': 'Žiadna kategória',
  'categories.emptyManage': 'Pridajte prvú kategóriu, napríklad Mliečne výrobky.',
  'categories.emptyRead': 'Firma zatiaľ nemá kategórie, alebo filter nič nenašiel.',
  'categories.deleteTitle': 'Zmazať kategóriu {name}?',
  'categories.deleteMessage': 'Kategória sa zmaže natrvalo.',
  'categories.deleteChildren': 'Kategória má podkategórie ({count}) — najprv ich presuňte alebo zmažte.',
  'categories.deleteMove': 'Presunúť jej produkty ({count}) do nadradenej kategórie',
  'categories.deleteMoveTop': 'Odobrať ju jej produktom ({count}) — je na najvyššej úrovni',
  'categories.depthHint': 'Strom môže mať najviac {max} úrovní.',
  'categories.viewProducts': 'Zobraziť produkty',
  'brands.title': 'Značky',
  'brands.subtitle': 'Značky a výrobcovia produktov firmy.',
  'brands.create': 'Nová značka',
  'brands.edit': 'Upraviť značku',
  'brands.name': 'Názov',
  'brands.nameHint': 'Vlastné meno — rovnaké vo všetkých jazykoch.',
  'brands.description': 'Popis',
  'brands.active': 'Aktívna',
  'brands.inactive': 'neaktívna',
  'brands.onlyActive': 'Len aktívne',
  'brands.products': 'Produkty',
  'brands.logo': 'Logo',
  'brands.logoUpload': 'Nahrať logo',
  'brands.logoReplace': 'Nahradiť logo',
  'brands.logoRemove': 'Odobrať logo',
  'brands.logoHint': 'JPEG, PNG, WebP alebo HEIC, najviac 15 MB.',
  'brands.noLogo': 'Bez loga',
  'brands.searchHint': 'názov značky',
  'brands.empty': 'Žiadna značka',
  'brands.emptyManage': 'Pridajte prvú značku alebo výrobcu.',
  'brands.emptyRead': 'Firma zatiaľ nemá značky, alebo filter nič nenašiel.',
  'brands.deleteTitle': 'Zmazať značku {name}?',
  'brands.deleteMessage': 'Jej produkty ({count}) zostanú bez značky a logo sa zmaže.',
  'tags.title': 'Štítky',
  'tags.subtitle': 'Štítky na produktoch — akcia, novinka, bio.',
  'tags.create': 'Nový štítok',
  'tags.edit': 'Premenovať štítok',
  'tags.name': 'Názov',
  'tags.products': 'Produkty',
  'tags.searchHint': 'názov v ktoromkoľvek jazyku',
  'tags.empty': 'Žiadny štítok',
  'tags.emptyManage': 'Pridajte prvý štítok, napríklad akcia.',
  'tags.emptyRead': 'Firma zatiaľ nemá štítky, alebo filter nič nenašiel.',
  'tags.deleteTitle': 'Zmazať štítok {name}?',
  'tags.deleteMessage': 'Štítok sa odoberie z produktov ({count}).',
  'features.title': 'Vlastnosti',
  'features.subtitle': 'Čím firma opisuje produkty bez variantov — materiál, krajina pôvodu, alergény.',
  'features.create': 'Nová vlastnosť',
  'features.rename': 'Premenovať vlastnosť',
  'features.name': 'Názov vlastnosti',
  'features.values': 'Hodnoty',
  'features.editValues': 'Hodnoty',
  'features.valuesTitle': 'Hodnoty vlastnosti {name}',
  'features.newValue': 'Nová hodnota',
  'features.addValue': 'Pridať',
  'features.renameValue': 'Premenovať hodnotu',
  'features.noValues': 'Bez preddefinovaných hodnôt — produkty uvádzajú vlastný text',
  'features.position': 'Poradie',
  'features.products': 'Produkty',
  'features.valueProducts': '{count} produktov',
  'features.searchHint': 'vlastnosť alebo hodnota',
  'features.empty': 'Žiadna vlastnosť',
  'features.emptyManage': 'Pridajte prvú vlastnosť, napríklad Materiál s hodnotami bavlna a polyester.',
  'features.emptyRead': 'Firma zatiaľ nemá vlastnosti, alebo filter nič nenašiel.',
  'features.deleteTitle': 'Zmazať vlastnosť {name}?',
  'features.deleteMessage': 'Vlastnosť sa zmaže aj s hodnotami a jej produkty ({count}) o ňu prídu.',
  'classification.title': 'Zaradenie',
  'classification.categories': 'Kategórie',
  'classification.categoriesHint': 'Hlavnú kategóriu označte hviezdičkou.',
  'classification.main': 'Hlavná kategória',
  'classification.markMain': 'Nastaviť ako hlavnú',
  'classification.mainChip': 'hlavná',
  'classification.brand': 'Značka',
  'classification.noBrand': 'Bez značky',
  'classification.tags': 'Štítky',
  'classification.tagsHint': 'Nový štítok napíšte a stlačte Enter — vytvorí sa pri uložení.',
  'classification.features': 'Vlastnosti',
  'classification.featureNone': 'Nevyplnené',
  'classification.featureCustom': 'Vlastný text…',
  'classification.customText': 'Vlastný text',
  'classification.customDefaultRequired': 'Vlastný text vlastnosti vyplňte aspoň v predvolenom jazyku.',
  'classification.noCategories': 'Bez kategórie',
  'classification.noTags': 'Bez štítkov',
  'classification.noFeatures': 'Bez vlastností',
  'classification.noFeatureGroups': 'Firma zatiaľ nemá vlastnosti — pridáte ich v Sklad › Vlastnosti.',
  'classification.ownText': 'vlastný text',
  'products.mainCategory': 'Hlavná kategória',
  'products.brand': 'Značka',
  'products.category': 'Kategória',
  'products.tag': 'Štítok',
  'legal.title': 'Právne údaje',
  'legal.condition': 'Stav tovaru',
  'condition.NEW': 'Nový',
  'condition.USED': 'Použitý',
  'condition.REFURBISHED': 'Repasovaný',
  'legal.showCondition': 'Zobraziť stav tovaru v e-shope',
  'legal.conditionShown': 'zobrazený v e-shope',
  'legal.conditionHidden': 'v e-shope sa nezobrazuje',
  'legal.unitPrice': 'Jednotková cena',
  'legal.unitLabel': 'Jednotka',
  'legal.noUnit': 'Bez jednotkovej ceny',
  'legal.unitQuantity': 'Množstvo v balení',
  'legal.unitQuantityHint': 'Koľko jednotiek produkt obsahuje — napr. 0,5 pri 500 g a cene za kg.',
  'legal.unitPriceValue': '{price} / {unit}',
  'legal.unitPriceNone': 'Jednotková cena sa vypočíta z ceny, jednotky a množstva.',
  'legal.unitPriceHint': 'EÚ ju vyžaduje pri tovare predávanom na hmotnosť, objem, dĺžku alebo plochu.',
  'legal.packOf': '{quantity} {unit} v balení',
  'legal.ecotax': 'Recyklačný poplatok s DPH ({currency})',
  'legal.ecotaxLabel': 'Recyklačný poplatok',
  'legal.ecotaxHint': 'Je súčasťou ceny, nepripočítava sa k nej — rovnako ako v PrestaShope.',
  'legal.ecotaxNone': 'Bez poplatku',
  'legal.unitIncomplete': 'Jednotkovú cenu zadajte s jednotkou aj množstvom, alebo nechajte obe prázdne.',
  'legal.unitQuantityInvalid': 'Množstvo v balení je kladné číslo s najviac tromi desatinnými miestami.',
  'legal.ecotaxAbovePrice': 'Recyklačný poplatok nemôže byť vyšší ako cena.',
  'legal.variantUnitQuantity': 'Množstvo v balení ({unit})',
  'legal.variantUnitQuantityHint': 'Prázdne = množstvo produktu ({quantity} {unit}).',
  'unit.kg': 'kilogram (kg)',
  'unit.g': 'gram (g)',
  'unit.l': 'liter (l)',
  'unit.ml': 'mililiter (ml)',
  'unit.m': 'meter (m)',
  'unit.m2': 'meter štvorcový (m²)',
  'unit.piece': 'kus (ks)',
  'unitSymbol.kg': 'kg',
  'unitSymbol.g': 'g',
  'unitSymbol.l': 'l',
  'unitSymbol.ml': 'ml',
  'unitSymbol.m': 'm',
  'unitSymbol.m2': 'm²',
  'unitSymbol.piece': 'ks',
  'availability.title': 'Dostupnosť',
  'availability.texts': 'Texty dostupnosti',
  'availability.availableNow': 'Text, keď je na sklade',
  'availability.availableNowHint': 'Napr. „Skladom“.',
  'availability.availableLater': 'Text, keď nie je na sklade',
  'availability.availableLaterHint': 'Napr. „Do 3 dní“ — pri objednávke na dodanie alebo predobjednávke.',
  'availability.availableFrom': 'Dostupné od',
  'availability.availableFromHint': 'Pri predobjednávke: odkedy sa tovar odosiela.',
  'availability.flags': 'Objednávanie',
  'availability.availableForOrder': 'Možno objednať',
  'availability.showPrice': 'Zobraziť cenu',
  'availability.showPriceHint': 'Produkt so skrytou cenou si nemožno objednať.',
  'availability.onlineOnly': 'Len online (nie v predajni)',
  'availability.onSaleBadge': 'Štítok „Výpredaj“ v e-shope',
  'availability.onSaleBadgeHint': 'Nezávisle od akciovej ceny.',
  'availability.noText': 'Bez textu v tomto jazyku.',
  'availability.noDate': 'Bez dátumu',
  'availability.priceHiddenOrderable':
    'Produkt so skrytou cenou si nemožno objednať — vypnite aj „Možno objednať“.',
  'seo.title': 'SEO',
  'seo.metaTitle': 'Titulok pre vyhľadávače',
  'seo.metaDescription': 'Popis pre vyhľadávače',
  'seo.count': '{count} / {max} znakov',
  'seo.countLong': '{count} / {max} znakov — vyhľadávače zobrazia asi {advised}',
  'seo.titleFallback': 'Keď je prázdny, e-shopy použijú názov produktu.',
  'seo.descriptionFallback': 'Keď je prázdny, e-shopy použijú krátky popis produktu.',
  'seo.usesName': 'Prázdne — e-shopy použijú názov: {name}',
  'seo.usesShortDescription': 'Prázdne — e-shopy použijú krátky popis.',
  'seo.tooLong': 'SEO titulok má najviac 70 znakov a SEO popis najviac 160.',
  'relations.title': 'Súvisiace produkty',
  'relations.hint':
    'Ktoré produkty e-shop ponúkne spolu s týmto. PrestaShop zobrazuje príslušenstvo; WooCommerce súvisiace (up-sell) a doplnkové (cross-sell) produkty.',
  'relations.kind.ACCESSORY': 'Príslušenstvo',
  'relations.kind.UP_SELL': 'Lepšia alternatíva (up-sell)',
  'relations.kind.CROSS_SELL': 'Doplnkové produkty (cross-sell)',
  'relations.shops.ACCESSORY': 'PrestaShop',
  'relations.shops.UP_SELL': 'WooCommerce',
  'relations.shops.CROSS_SELL': 'WooCommerce',
  'relations.kindHint.ACCESSORY': 'Zobrazí sa na stránke produktu.',
  'relations.kindHint.UP_SELL': 'Ponúkne sa namiesto tohto produktu na jeho stránke.',
  'relations.kindHint.CROSS_SELL': 'Ponúkne sa v košíku popri tomto produkte.',
  'relations.empty': 'Zatiaľ žiadne.',
  'relations.add': 'Pridať produkt',
  'relations.searchHint': 'názov, SKU alebo EAN',
  'relations.reciprocal': 'Pridať aj opačne',
  'relations.moveUp': 'Posunúť vyššie',
  'relations.moveDown': 'Posunúť nižšie',
  'relations.remove': 'Odobrať',
  'relations.archived': 'archivovaný',
  'field.productType': 'Typ produktu',
  'productType.STANDARD': 'Bežný produkt',
  'productType.PACK': 'Balíček',
  'productType.hint.STANDARD': 'Tovar so zásobami v šaržiach.',
  'productType.hint.PACK':
    'Zložený z variantov iných produktov. Nemá vlastné zásoby ani šarže — predá toľko balíčkov, koľko dovolí najvzácnejšia položka.',
  'products.section.type': 'Typ',
  'products.packsAvailable': 'Dostupné balíčky',
  'products.packItemCount': 'Položky balíčka',
  'products.packHint': 'z položiek',
  'pack.title': 'Obsah balíčka',
  'pack.hint':
    'Balíček nemá vlastné zásoby: predá toľko balíčkov, koľko dovolí najvzácnejšia položka. Predaj balíčka vydá jeho položky z ich šarží (FEFO) v jednej operácii; vrátenie ich vráti.',
  'pack.available': 'Dostupné: {count} bal.',
  'pack.limitedBy': 'Obmedzuje: {name}',
  'pack.limiting': 'obmedzuje',
  'pack.empty': 'Balíček zatiaľ nemá žiadne položky — pridajte produkty, z ktorých sa skladá.',
  'pack.add': 'Pridať produkt',
  'pack.searchHint': 'názov, SKU alebo EAN',
  'pack.variant': 'Variant',
  'pack.quantity': 'Ks v balíčku',
  'pack.addButton': 'Pridať',
  'pack.onHand': '{count} ks na sklade',
  'pack.covers': 'stačí na {count} bal.',
  'pack.perPack': '× {count}',
  'pack.archived': 'archivovaný',
  'pack.moveUp': 'Posunúť vyššie',
  'pack.moveDown': 'Posunúť nižšie',
  'pack.remove': 'Odobrať z balíčka',
  'pack.quantityInvalid': 'Množstvo musí byť celé číslo od 1 do 9 999.',
  'pack.variantRequired': 'Vyberte variant.',
  'stock.packIssueHint':
    'Vydá sa {count} bal. — každá položka zo svojich šarží podľa FEFO, všetko v jednej operácii; ak niektorej chýba, nevydá sa nič:',
  'stock.packIssueLine': '{name}: {count} ks',
  'movements.inPack': 'v balíčku {name}',
  'productType.VIRTUAL': 'Virtuálny produkt',
  'productType.hint.VIRTUAL': 'Nič sa neposiela — e-kniha, poukážka, licencia.',
  'files.downloadsTitle': 'Na stiahnutie',
  'files.downloadsHint':
    'Čo zákazník dostane s virtuálnym produktom — súkromné, otvára ich iba odkaz platný 5 minút. PDF, ZIP, obrázky, text, Office, EPUB, MP3, MP4; najviac {maxMb} MB.',
  'files.attachmentsTitle': 'Prílohy',
  'files.attachmentsHint':
    'Dokumenty na stránke produktu — návody, bezpečnostné listy. PDF, ZIP, obrázky, text, Office; najviac {maxMb} MB.',
  'files.downloadsEmpty': 'Zatiaľ žiadne súbory na stiahnutie — nahrajte, čo zákazník dostane.',
  'files.attachmentsEmpty': 'Zatiaľ žiadne prílohy.',
  'files.upload': 'Nahrať súbor',
  'files.uploading': 'Nahráva sa… {percent} %',
  'files.open': 'Otvoriť',
  'files.edit': 'Upraviť',
  'files.editTitle': 'Upraviť súbor',
  'files.remove': 'Odstrániť',
  'files.removeTitle': 'Odstrániť súbor?',
  'files.removeMessage': 'Súbor „{name}“ sa odstráni z produktu aj z úložiska.',
  'files.moveUp': 'Posunúť vyššie',
  'files.moveDown': 'Posunúť nižšie',
  'files.name': 'Názov',
  'files.description': 'Popis',
  'files.maxDownloads': 'Počet stiahnutí',
  'files.validityDays': 'Platnosť (dni)',
  'files.unlimitedHint': 'Prázdne — bez obmedzenia.',
  'files.downloadsCount': '{count}× stiahnuť',
  'files.daysCount': '{count} dní',
  'files.limitInvalid': 'Počet stiahnutí je celé číslo od 1 do 1 000 000, platnosť od 1 do 3 650 dní.',
  'files.typeRefused': 'Tento druh súboru sa sem nedá nahrať.',
  'files.tooLarge': 'Súbor je prázdny alebo väčší ako {maxMb} MB.',
  'products.alwaysAvailable': 'Vždy dostupný',
  'products.virtualMeasures': 'Virtuálny produkt sa neposiela — hmotnosť a rozmery sa pri uložení vymažú.',
  'customization.title': 'Prispôsobenie',
  'customization.hint':
    'Čo zákazník vyplní pri objednávke v e-shope — text alebo súbor (napr. fotka). Hodnoty, ktoré zadá, prídu s objednávkami neskôr.',
  'customization.empty': 'Produkt sa neprispôsobuje.',
  'customization.add': 'Pridať pole',
  'customization.edit': 'Upraviť pole',
  'customization.remove': 'Odstrániť pole',
  'customization.moveUp': 'Posunúť vyššie',
  'customization.moveDown': 'Posunúť nižšie',
  'customization.label': 'Názov poľa',
  'customization.type': 'Druh',
  'customization.type.TEXT': 'Text',
  'customization.type.FILE': 'Súbor',
  'customization.required': 'Povinné — bez neho sa objednávka neodošle',
  'customization.requiredChip': 'povinné',
  'customization.labelRequired': 'Vyplňte názov v predvolenom jazyku.',
  'nav.transfers': 'Prenos dát',
  'movementReason.TRANSFER_IMPORT': 'Import zo súboru',
  'transfers.title': 'Prenos dát',
  'transfers.subtitle':
    'Katalóg a zásoby firmy do súboru a zo súboru — do inej firmy, iného podniku alebo z e-shopu bez prepojenia.',
  'transfers.noCompanyDetail': 'Prenos dát patrí firme. Najprv vytvorte firmu.',
  'transfers.history': 'História prenosov',
  'transfers.exportTitle': 'Export',
  'transfers.exportHint':
    'Produkty s variantmi, textami vo všetkých jazykoch, cenami, kategóriami, značkami, vlastnosťami a zásobami po šaržiach. Súbor sa pripraví na pozadí a dá sa stiahnuť 7 dní; pošleme vám aj e-mail.',
  'transfers.scopeAll': 'Celý katalóg',
  'transfers.scopeCategory': 'Jedna kategória aj s podkategóriami',
  'transfers.category': 'Kategória',
  'transfers.includeMedia': 'Aj fotky a súbory produktov',
  'transfers.exportStart': 'Exportovať',
  'transfers.importTitle': 'Import',
  'transfers.importHint':
    'Súbor ZIP z exportu (najviac {maxMb} MB) sa nahrá priamo do úložiska a skontroluje. V náhľade uvidíte, čo sa vytvorí, doplní alebo preskočí, a až potom import potvrdíte.',
  'transfers.chooseFile': 'Vybrať súbor',
  'transfers.noFile': 'Nie je vybraný žiadny súbor',
  'transfers.uploading': 'Nahráva sa… {percent} %',
  'transfers.importStart': 'Nahrať a skontrolovať',
  'transfers.notZip': 'Importovať sa dá iba súbor ZIP vytvorený exportom.',
  'transfers.tooLarge': 'Súbor je prázdny alebo väčší ako {maxMb} MB.',
  'transfers.moreProblems': 'a ďalších {count} problémov',
  'transfers.itemSearch': 'Názov, SKU alebo EAN',
  'transfers.match': 'Zhoda',
  'transfers.outcome': 'Výsledok',
  'transfers.product': 'Produkt',
  'transfers.wouldDo': 'Čo sa stane',
  'transfers.itemShape': '{variants} variantov · {photos} fotiek',
  'transfers.matchedBy': 'Zhoda podľa {by}',
  'transfers.wouldSkip': 'Preskočí sa',
  'transfers.wouldCreate': 'Vytvorí sa',
  'transfers.noItems': 'Žiadne produkty',
  'transfers.direction': 'Smer',
  'transfers.status': 'Stav',
  'transfers.createdAt': 'Začatý',
  'transfers.what': 'Čo',
  'transfers.size': 'Veľkosť',
  'transfers.finishedAt': 'Skončený',
  'transfers.withMedia': 's fotkami a súbormi',
  'transfers.withoutMedia': 'bez fotiek a súborov',
  'transfers.noHistory': 'Zatiaľ žiadny prenos',
  'transfers.noHistoryDetail': 'Exportujte katalóg firmy alebo importujte súbor z iného exportu.',
  'transfers.download': 'Stiahnuť súbor',
  'transfers.availableUntil': 'K dispozícii do {date}',
  'transfers.previewTitle': 'Náhľad importu',
  'transfers.previewFrom': 'Súbor z {producer}, vytvorený {date}; jazyky {languages}.',
  'transfers.previewNew': 'Nové: {count}',
  'transfers.previewMatched': 'Už vo firme: {count}',
  'transfers.previewInvalid': 'Chybné: {count}',
  'transfers.previewVariants': 'Varianty: {count}',
  'transfers.previewStock': 'Šarže: {batches}, kusy: {quantity}',
  'transfers.previewMedia': 'Fotky a súbory: {count}',
  'transfers.previewTaxonomy': '{kind}: {total} (nové {new})',
  'transfers.modeLabel': 'Produkty, ktoré firma už má',
  'transfers.stockLabel': 'Zásoby zo súboru',
  'transfers.apply': 'Potvrdiť import',
  'transfers.importDone': 'Import je hotový ({mode}, {stock}).',
  'transferDirection.EXPORT': 'Export',
  'transferDirection.IMPORT': 'Import',
  'transferStatus.AWAITING_UPLOAD': 'Čaká na súbor',
  'transferStatus.QUEUED': 'V poradí',
  'transferStatus.RUNNING': 'Prebieha',
  'transferStatus.VALIDATING': 'Kontroluje sa',
  'transferStatus.READY': 'Čaká na potvrdenie',
  'transferStatus.APPLYING': 'Importuje sa',
  'transferStatus.DONE': 'Hotový',
  'transferStatus.FAILED': 'Neúspešný',
  'transferStatus.EXPIRED': 'Súbor vypršal',
  'transferStatusHint.AWAITING_UPLOAD': 'Súbor sa nahráva do úložiska.',
  'transferStatusHint.QUEUED': 'Čaká, kým sa ho ujme spracovanie na pozadí.',
  'transferStatusHint.RUNNING': 'Súbor sa pripravuje.',
  'transferStatusHint.VALIDATING': 'Kontroluje sa súbor — obsah, odtlačky a štruktúra.',
  'transferStatusHint.APPLYING': 'Produkty a zásoby sa importujú.',
  'transferPhase.TAXONOMY': 'Kategórie a vlastnosti',
  'transferPhase.PRODUCTS': 'Produkty',
  'transferPhase.LINKS': 'Súvisiace produkty a balíčky',
  'transferPhase.STOCK': 'Zásoby',
  'transferPhase.FINISH': 'Dokončenie',
  'transferMode.CREATE_ONLY': 'Iba vytvoriť nové',
  'transferMode.FILL_EMPTY': 'Doplniť prázdne údaje',
  'transferMode.OVERWRITE': 'Prepísať podľa súboru',
  'transferMode.hint.CREATE_ONLY': 'Produkty, ktoré firma má, sa nezmenia.',
  'transferMode.hint.FILL_EMPTY': 'Doplnia sa iba údaje, ktoré produkt nemá; nič sa neprepíše.',
  'transferMode.hint.OVERWRITE': 'Produkt bude taký, aký je v súbore — texty, ceny, varianty, fotky, súbory.',
  'transferMode.would.CREATE_ONLY': 'Preskočí sa',
  'transferMode.would.FILL_EMPTY': 'Doplní sa',
  'transferMode.would.OVERWRITE': 'Prepíše sa',
  'transferStock.SET_LEVELS': 'Nastaviť stavy',
  'transferStock.ADD_RECEIPT': 'Pridať ako príjem',
  'transferStock.IGNORE': 'Ignorovať',
  'transferStock.hint.SET_LEVELS': 'Každá šarža bude mať množstvo zo súboru — inventúrnym pohybom.',
  'transferStock.hint.ADD_RECEIPT': 'Množstvá zo súboru sa pripočítajú príjmom.',
  'transferStock.hint.IGNORE': 'Zásoby sa nezmenia.',
  'transferMatch.NEW': 'Nový',
  'transferMatch.MATCHED': 'Už vo firme',
  'transferMatch.INVALID': 'Chybný',
  'transferMatchedBy.SKU': 'SKU',
  'transferMatchedBy.EAN': 'EAN',
  'transferMatchedBy.NAME': 'názvu',
  'transferOutcome.CREATED': 'Vytvorený',
  'transferOutcome.UPDATED': 'Aktualizovaný',
  'transferOutcome.SKIPPED': 'Preskočený',
  'transferOutcome.FAILED': 'Neúspešný',
  'transferCount.products': 'Produkty',
  'transferCount.variants': 'Varianty',
  'transferCount.batches': 'Šarže',
  'transferCount.taxonomy': 'Kategórie a vlastnosti',
  'transferCount.media': 'Fotky a súbory',
  'transferCount.created': 'Vytvorené',
  'transferCount.updated': 'Aktualizované',
  'transferCount.skipped': 'Preskočené',
  'transferCount.failed': 'Neúspešné',
  'transferCount.taxonomyCreated': 'Nové kategórie a vlastnosti',
  'transferCount.variantsCreated': 'Nové varianty',
  'transferCount.batchesCreated': 'Nové šarže',
  'transferCount.photos': 'Uložené fotky',
  'transferCount.files': 'Uložené súbory',
  'transferCount.movements': 'Pohyby zásob',
  'transferCount.quantity': 'Pohnuté kusy',
  'taxonomyKind.category': 'Kategórie',
  'taxonomyKind.brand': 'Značky',
  'taxonomyKind.tag': 'Štítky',
  'taxonomyKind.option-group': 'Možnosti variantov',
  'taxonomyKind.feature-group': 'Vlastnosti',
  'transferProblem.UPLOAD_MISSING': 'Súbor sa v úložisku nenašiel. Nahrajte ho znova.',
  'transferProblem.UPLOAD_TOO_LARGE': 'Súbor je väčší ako {maxMb} MB.',
  'transferProblem.UPLOAD_CHANGED': 'Súbor sa od kontroly zmenil. Nahrajte ho a skontrolujte znova.',
  'transferProblem.PACKAGE_UNREADABLE': 'Súbor nie je čitateľný ZIP.',
  'transferProblem.MANIFEST_MISSING': 'V súbore chýba manifest.json — nie je to súbor z exportu.',
  'transferProblem.MANIFEST_INVALID': 'Manifest súboru je poškodený.',
  'transferProblem.FORMAT_NEWER':
    'Súbor je v novšom formáte ({format}), než aký aplikácia pozná ({supported}). Aktualizujte aplikáciu alebo exportujte súbor znova.',
  'transferProblem.FORMAT_UNKNOWN': 'Súbor nie je v známom formáte ({format}).',
  'transferProblem.FILE_MISSING': 'V súbore chýba {path}.',
  'transferProblem.FILE_UNLISTED': 'Súbor obsahuje {path}, ktorý do exportu nepatrí.',
  'transferProblem.FILE_TOO_LARGE': '{path} je väčší ako {maxMb} MB.',
  'transferProblem.HASH_MISMATCH': '{path} bol po exporte zmenený — jeho obsah nezodpovedá odtlačku.',
  'transferProblem.SCHEMA': 'Časť súboru nemá správnu štruktúru.',
  'transferProblem.DUPLICATE_REF': 'Záznam {ref} je v súbore dvakrát.',
  'transferProblem.MEDIA_MISSING': 'Fotka alebo súbor {path} v súbore chýba.',
  'transferProblem.NO_MEDIA': 'Súbor neobsahuje fotky ani súbory produktov — importujú sa bez nich.',
  'transferProblem.LANGUAGE_MISSING':
    'Texty v jazykoch {languages} sa nenaimportujú — podnik ich nemá medzi jazykmi obsahu.',
  'transferProblem.CURRENCY_MISMATCH': 'Ceny v súbore sú v {package}, firma účtuje v {company}.',
  'transferProblem.LICENCE_PRODUCTS':
    'Import by vytvoril {needed} produktov, licencia má miesto ešte pre {room}.',
  'transferProblem.LICENCE_STOCK':
    'Zásoby zo súboru ({needed} ks) presahujú voľné miesto v licencii ({room} ks); časť sa nenaimportuje.',
  'transferProblem.LICENCE_RESTRICTED': 'Licencia neumožňuje zmeny — import sa zastavil.',
  'transferProblem.TAXONOMY': 'Položka taxonómie {ref} sa nenaimportovala.',
  'transferProblem.STOCK': 'Zásoby {ref} sa nenaimportovali.',
  'transferProblem.LINKS': 'Súvisiace produkty alebo balíček produktu {ref} sa nenaimportovali celé.',
  'transferProblem.FAILED': 'Prenos sa nepodaril.',
  'transferReason.MATCHED': 'Firma ho už má (iba vytvoriť nové).',
  'transferReason.NOTHING_EMPTY': 'Nebolo čo doplniť.',
  'transferReason.ARCHIVED': 'Produkt je archivovaný.',
  'transferReason.INVALID': 'Súbor ho odmietol.',
  'transferReason.SCHEMA': 'Záznam v súbore nie je platný.',
  'transferReason.REFUSED': 'Aplikácia zmenu odmietla.',
  'nav.contacts': 'Kontakty',
  'contacts.title': 'Kontakty',
  'contacts.subtitle': 'Zákazníci, partneri a dodávatelia firmy — ich e-maily, telefóny, adresy a poznámky.',
  'contacts.noCompanyDetail':
    'Kontakty patria firme. Vytvorte firmu alebo požiadajte o prístup ku kontaktom.',
  'contacts.new': 'Nový kontakt',
  'contacts.labels': 'Štítky',
  'contacts.import': 'Importovať',
  'contacts.export': 'Exportovať',
  'contacts.search': 'Hľadať — názov, e-mail, telefón, IČO, mesto, osoba',
  'contacts.kind': 'Druh',
  'contacts.type': 'Typ',
  'contacts.label': 'Štítok',
  'contacts.country': 'Krajina',
  'contacts.doNotContact': 'Nekontaktovať',
  'contacts.dnc.only': 'Len nekontaktovať',
  'contacts.dnc.exclude': 'Okrem nekontaktovať',
  'contacts.name': 'Názov',
  'contacts.email': 'E-mail',
  'contacts.phone': 'Telefón',
  'contacts.city': 'Mesto',
  'contacts.ico': 'IČO',
  'contacts.updatedAt': 'Zmenené',
  'contacts.empty': 'Žiadne kontakty',
  'contacts.emptyDetail': 'Pridajte kontakt alebo importujte súbor ZIP s kontaktmi.',
  'contacts.emptyFiltered': 'Filtru nezodpovedá žiadny kontakt.',
  'contactKind.ORGANISATION': 'Organizácia',
  'contactKind.PERSON': 'Osoba',
  'contactType.CUSTOMER': 'Zákazník',
  'contactType.SUPPLIER': 'Dodávateľ',
  'contactType.PARTNER': 'Partner',
  'contactType.OTHER': 'Iný',
  'contact.createTitle': 'Nový kontakt',
  'contact.delete': 'Zmazať',
  'contact.deleteTitle': 'Zmazať kontakt',
  'contact.deleteMessage': 'Kontakt {name} sa zmaže aj s poznámkami a históriou. Nedá sa to vrátiť.',
  'contact.created': 'Vytvoril {email}, {date}',
  'contact.updated': 'Naposledy zmenil {email}, {date}',
  'contact.someone': 'neznámy',
  'contact.section.identity': 'Údaje',
  'contact.section.emails': 'E-maily',
  'contact.section.phones': 'Telefóny',
  'contact.section.addresses': 'Adresy',
  'contact.section.persons': 'Kontaktné osoby',
  'contact.section.websites': 'Web a sociálne siete',
  'contact.section.description': 'Popis',
  'contact.section.labels': 'Štítky',
  'contact.section.notes': 'Poznámky',
  'contact.section.history': 'História zmien',
  'contact.name': 'Názov',
  'contact.legalName': 'Obchodné meno',
  'contact.ico': 'IČO',
  'contact.dic': 'DIČ',
  'contact.icDph': 'IČ DPH',
  'contact.doNotContactHint': 'Neposielať ponuky ani iné správy.',
  'contact.primary': 'Hlavný',
  'contact.makePrimary': 'Nastaviť ako hlavný',
  'contact.billing': 'Fakturačná',
  'contact.operating': 'Prevádzka',
  'contact.makeBilling': 'Nastaviť ako fakturačnú',
  'contact.addEmail': 'Pridať e-mail',
  'contact.addPhone': 'Pridať telefón',
  'contact.addAddress': 'Pridať adresu',
  'contact.addPerson': 'Pridať osobu',
  'contact.addWebsite': 'Pridať odkaz',
  'contact.remove': 'Odstrániť',
  'contact.rowLabel': 'Označenie',
  'contact.rowLabelHint': 'napr. objednávky, fakturácia',
  'contact.note': 'Poznámka',
  'contact.street': 'Ulica a číslo',
  'contact.city': 'Mesto',
  'contact.postalCode': 'PSČ',
  'contact.countryCode': 'Krajina',
  'contact.countryHint': 'SK, CZ, AT…',
  'contact.personName': 'Meno',
  'contact.role': 'Funkcia',
  'contact.url': 'Adresa',
  'contact.linkKind': 'Druh',
  'contact.phoneHint': 'Bez predvoľby sa berie ako slovenské číslo.',
  'contact.none': 'Nič',
  'contact.noLabels': 'Firma zatiaľ nemá štítky — pridáte ich tlačidlom Štítky v zozname kontaktov.',
  'websiteKind.WEB': 'Web',
  'websiteKind.FACEBOOK': 'Facebook',
  'websiteKind.INSTAGRAM': 'Instagram',
  'websiteKind.LINKEDIN': 'LinkedIn',
  'websiteKind.OTHER': 'Iný',
  'contactNotes.add': 'Pridať poznámku',
  'contactNotes.placeholder': 'Napíšte poznámku — napr. čo ste dohodli, kedy sa ozvať…',
  'contactNotes.empty': 'Zatiaľ žiadne poznámky.',
  'contactNotes.edited': 'upravené {date}',
  'contactNotes.deleteTitle': 'Zmazať poznámku',
  'contactNotes.deleteMessage': 'Poznámka sa zmaže. V histórii zmien zostane jej začiatok.',
  'contactHistory.empty': 'Zatiaľ žiadne zmeny.',
  'contactHistory.more': 'Načítať staršie',
  'contactHistory.action.CREATED': 'Vytvorený',
  'contactHistory.action.UPDATED': 'Upravený',
  'contactHistory.action.IMPORTED': 'Importovaný',
  'contactHistory.action.NOTE_ADDED': 'Pridaná poznámka',
  'contactHistory.action.NOTE_EDITED': 'Upravená poznámka',
  'contactHistory.action.NOTE_DELETED': 'Zmazaná poznámka',
  'contactHistory.field.kind': 'Druh',
  'contactHistory.field.type': 'Typ',
  'contactHistory.field.name': 'Názov',
  'contactHistory.field.legalName': 'Obchodné meno',
  'contactHistory.field.ico': 'IČO',
  'contactHistory.field.dic': 'DIČ',
  'contactHistory.field.icDph': 'IČ DPH',
  'contactHistory.field.doNotContact': 'Nekontaktovať',
  'contactHistory.field.description': 'Popis',
  'contactHistory.field.emails': 'E-maily',
  'contactHistory.field.phones': 'Telefóny',
  'contactHistory.field.addresses': 'Adresy',
  'contactHistory.field.persons': 'Kontaktné osoby',
  'contactHistory.field.websites': 'Odkazy',
  'contactHistory.field.labels': 'Štítky',
  'contactHistory.field.note': 'Poznámka',
  'contactHistory.yes': 'áno',
  'contactHistory.no': 'nie',
  'contactLabels.title': 'Štítky kontaktov',
  'contactLabels.new': 'Nový štítok',
  'contactLabels.name': 'Názov',
  'contactLabels.count': '{count} kontaktov',
  'contactLabels.empty': 'Firma zatiaľ nemá štítky. Napríklad reštaurácia, hotel, veľkoobchod.',
  'contactLabels.add': 'Pridať',
  'contactLabels.rename': 'Premenovať',
  'contactLabels.deleteTitle': 'Zmazať štítok',
  'contactLabels.deleteMessage': 'Štítok {name} sa zmaže a zmizne zo všetkých kontaktov.',
  'contactImport.title': 'Import kontaktov',
  'contactImport.intro':
    'Vyberte súbor ZIP exportovaný z aplikácie. Najprv uvidíte, čo import urobí — nič sa nezapíše, kým to nepotvrdíte.',
  'contactImport.choose': 'Vybrať súbor ZIP',
  'contactImport.check': 'Skontrolovať',
  'contactImport.uploading': 'Nahrávam… {percent} %',
  'contactImport.summary':
    '{total} riadkov: {creates} nových, {updates} doplní existujúci kontakt, {errors} s chybou.',
  'contactImport.labelsToCreate': 'Vytvoria sa štítky: {labels}',
  'contactImport.rules':
    'Existujúci kontakt sa nájde podľa IČO, potom podľa hlavného e-mailu, a riadok bez nich podľa názvu. Import ho doplní — nič z neho nezmaže. Riadok s chybou sa preskočí.',
  'contactImport.confirm': 'Importovať {count}',
  'contactImport.done':
    'Hotovo: {created} vytvorených, {updated} doplnených, {refused} preskočených, {labels} nových štítkov.',
  'contactImport.outcome': 'Výsledok',
  'contactImport.position': 'Riadok',
  'contactImport.detail': 'Podrobnosti',
  'contactImport.searchRows': 'Hľadať v riadkoch',
  'contactImport.outcome.CREATE': 'Nový',
  'contactImport.outcome.UPDATE': 'Doplní',
  'contactImport.outcome.ERROR': 'Chyba',
  'contactImport.matchedBy.ICO': 'podľa IČO',
  'contactImport.matchedBy.EMAIL': 'podľa e-mailu',
  'contactImport.matchedBy.NAME': 'podľa názvu',
  'contactImport.aboveRow': 'kontakt z riadku vyššie',
  'contactImport.problem.NOT_AN_OBJECT': 'Riadok nie je kontakt.',
  'contactImport.problem.NAME_REQUIRED': 'Chýba názov.',
  'contactImport.problem.KIND_INVALID': 'Neznámy druh „{value}“.',
  'contactImport.problem.TYPE_INVALID': 'Neznámy typ „{value}“.',
  'contactImport.problem.EMAIL_INVALID': '„{value}“ nie je e-mail.',
  'contactImport.problem.PHONE_INVALID': '„{value}“ nie je telefónne číslo.',
  'contactImport.problem.COUNTRY_INVALID': '„{value}“ nie je kód krajiny.',
  'contactImport.problem.LIST_TOO_LONG': 'Príliš veľa položiek v zozname.',
  'contactImport.problem.VALUE_INVALID': 'Neplatná hodnota „{value}“.',
} as const;

export type MessageKey = keyof typeof SK;
